import React from 'react';
import { CrossSellLightBoxStore } from '../../_flux/stores/cross_sell_light_box_store';
import { CrossSellLightBox } from '../../_flux/components/cross_sell_light_box/cross_sell_light_box';
import { expandAction, hideAction } from '../../_flux/actions/cross_sell_light_box_actions';
import LightboxStore from '../../_flux/stores/lightbox_store';
import { clickOnLearnMore, close } from '../../_modules/google_analytics/cross_sell_light_box';
import { handleView } from '../handle_view';

const stores = {
    crossSellLightBox: CrossSellLightBoxStore,
    lightBox: LightboxStore,
};

function render(
    {
        crossSellLightBox,
        lightBox,
    },
) {
    const { visible, expanded } = crossSellLightBox;
    const LightBoxVisible = lightBox.visible;
    
    return (
        <CrossSellLightBox
            visible={visible}
            expanded={expanded}
            data={crossSellLightBox.obj}
            LightBoxVisible={LightBoxVisible}
            error={{ ...crossSellLightBox }}
            onExpand={onExpand}
            onClose={onClose}
        />
    );
}

const getOptions = options => ({
    ...options,
});

export const init = (container, options) =>
    handleView(stores, render, getOptions(options), container);

const onExpand = () => {
    expandAction();
    clickOnLearnMore();
};

export const onClose = () => {
    hideAction();
    close();
};